// Utility functions for Intercom Messenger

/**
 * Opens the Intercom Messenger widget programmatically
 */
export const openIntercom = () => {
  if (typeof window === "undefined") return;
  const IntercomWindow = window as unknown as Window & {
    Intercom?: (action: string, data?: unknown) => void;
  };
  if (IntercomWindow.Intercom) {
    try {
      IntercomWindow.Intercom("show");
    } catch (error) {
      // Silent fail - Could not open Intercom. TODO: error log this?
    }
  }
};

/**
 * Clears all Intercom-related cookies, localStorage, and sessionStorage
 */
export const clearIntercomData = () => {
  if (typeof document === "undefined") return;

  const cookieNames = [
    "intercom-id",
    "intercom-session",
    "intercom-device-id",
    "_intercom-id",
    "_intercom-session",
    "_intercom-device-id",
    "intercom",
    "_intercom",
  ];

  const domains = [
    window.location.hostname,
    `.${window.location.hostname}`,
    window.location.hostname.split(".").slice(-2).join("."),
    `.${window.location.hostname.split(".").slice(-2).join(".")}`,
  ];

  const paths = ["/", "/auth", "/dashboard"];

  cookieNames.forEach((cookieName) => {
    domains.forEach((domain) => {
      paths.forEach((path) => {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain};secure`;
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain};secure;samesite=none`;
      });
    });
  });

  // Rensa även alla cookies som börjar med intercom eller _intercom
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (name.toLowerCase().includes("intercom")) {
      domains.forEach((domain) => {
        paths.forEach((path) => {
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
        });
      });
    }
  });

  // Rensa även localStorage och sessionStorage
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.toLowerCase().includes("intercom")) {
        localStorage.removeItem(key);
      }
    });
    Object.keys(sessionStorage).forEach((key) => {
      if (key.toLowerCase().includes("intercom")) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) {
    // Silent fail
  }
};

